import angular from 'angular';
import uirouter from 'angular-ui-router';
import routing from './routes';

import ActivityController from './ActivityController';

// import homeActivity from '../../directives/homeActivity';
//
// import getMatchesNearMe from '../../directives/getMatchesNearMe';
//
// import getMatchActivity from '../../directives/getMatchActivity';

import panel from '../../services';

export default angular.module('app.activity', [uirouter, panel])
    .config(routing)
    .controller('ActivityController', ActivityController)
    .name;



// WEBPACK FOOTER //
// ./src/app/features/activity/index.js